import React, { useState } from "react";
import styles from "../../prepare-invoice/styles/prepareInvoice.module.scss";
import {
  Button,
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { ButtonAction } from "shared/components/ButtonAction";
import {
  AutocompleteSelect,
  AutocompleteSelectOption,
} from "shared/components";
import { MenuActions } from "pages/autorization-payments/components/MenuActions";
import { useFormAssociateDeduction } from "../hook/useFormAssociateDeduction";
import { columnsUsersType } from "../types/columsUsers.types";
import tableStyles from "../../read-documents/styles/tableResults.module.scss";
import { accesRoles } from "shared/models";

interface FormAssociateDeductionProps {
  user: columnsUsersType;
}

export const FormAssociateDeduction = ({
  user,
}: FormAssociateDeductionProps) => {
  const {
    deductions,
    handleDeductionChange,
    handleSubmit,
    associatedDeductions,
    handleRemoveDeduction,
  } = useFormAssociateDeduction(user);
  const [selectedDeductions, setSelectedDeductions] = useState<
    AutocompleteSelectOption[]
  >([]);

  // Mapear datos del servicio al formato de la tabla
  const tableDeductions = associatedDeductions.map((item) => ({
    id: item.deduction.id,
    codigoConcepto: item.deduction.conceptCode,
    nombreRetencion: item.deduction.conceptDescription,
    porcentajeRetencion: `${item.deduction.percentage}%`,
    nitBeneficiario: item.deduction.beneficiary,
    razonSocial: item.deduction.beneficiaryName,
  }));

  return (
    <>
      <div className={styles.container}>
        <Grid container>
          <Grid item xs={12}>
            <div
              style={{
                width: "97%",
                marginLeft: "auto",
                marginRight: "auto",
                display: "flex",
                alignItems: "flex-end",
                gap: "0.75rem",
                marginBottom: "0.75rem",
                flexWrap: "wrap",
              }}
            >
              <div style={{ flex: "1 1 320px" }}>
                <AutocompleteSelect
                  label="Asociar deducción"
                  placeholder="Seleccione deducciones"
                  options={deductions}
                  value={selectedDeductions}
                  onChange={(value) =>
                    setSelectedDeductions(value as AutocompleteSelectOption[])
                  }
                  onSearch={(text) => handleDeductionChange(text)}
                  multiple={true}
                  data-testid="associate-deduction-autocomplete"
                />
              </div>
              <Button
                variant="contained"
                color="secondary"
                className={styles.buttonSubmit}
                disabled={selectedDeductions.length === 0}
                data-testid="btn-associate-deduction"
                onClick={() => handleSubmit({ deductions: selectedDeductions })}
                sx={{
                  height: "40px",
                  minWidth: "140px",
                  alignSelf: "flex-end",
                }}
              >
                Asociar deducción
              </Button>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Paper
              className={tableStyles.containerTableResults}
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "1rem",
                marginBottom: "1rem",
                width: "97%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "auto",
              }}
            >
              <TableContainer
                className={tableStyles.tableResults}
                sx={{
                  maxWidth: "100%",
                  overflowX: "auto",
                  maxHeight: "262px",
                  overflow: "auto",
                  height: "auto",
                }}
              >
                <Table
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    tableLayout: "fixed",
                  }}
                  aria-label="tabla-retenciones-asociadas"
                  data-testid="table-associated-deductions"
                >
                  <TableHead>
                    <TableRow className={tableStyles.tablaHeader}>
                      <TableCell
                        align="left"
                        className={tableStyles.tableCell}
                        style={{ minWidth: 160 }}
                      >
                        Código concepto
                      </TableCell>
                      <TableCell
                        align="left"
                        className={tableStyles.tableCell}
                        style={{ minWidth: 220 }}
                      >
                        Nombre retención
                      </TableCell>
                      <TableCell
                        align="left"
                        className={tableStyles.tableCell}
                        style={{ minWidth: 160 }}
                      >
                        porcentaje retención
                      </TableCell>
                      <TableCell
                        align="left"
                        className={tableStyles.tableCell}
                        style={{ minWidth: 160 }}
                      >
                        NIT beneficiario
                      </TableCell>
                      <TableCell
                        align="left"
                        className={tableStyles.tableCell}
                        style={{ minWidth: 220 }}
                      >
                        Razón social
                      </TableCell>
                      <TableCell
                        align="left"
                        className={tableStyles.tableCell}
                        style={{ minWidth: 180 }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody data-testid="table-associated-deductions-body">
                    {tableDeductions.map((deduction, index) => (
                      <TableRow key={index}>
                        <TableCell
                          align="left"
                          className={tableStyles.tableCell}
                          data-testid="table-associated-deductions-cell-concept-code"
                        >
                          {deduction.codigoConcepto}
                        </TableCell>
                        <TableCell
                          align="left"
                          className={tableStyles.tableCell}
                          data-testid="table-associated-deductions-cell-name"
                        >
                          {deduction.nombreRetencion}
                        </TableCell>
                        <TableCell
                          align="left"
                          className={tableStyles.tableCell}
                          data-testid="table-associated-deductions-cell-percentage"
                        >
                          {deduction.porcentajeRetencion}
                        </TableCell>
                        <TableCell
                          align="left"
                          className={tableStyles.tableCell}
                          data-testid="table-associated-deductions-cell-nit"
                        >
                          {deduction.nitBeneficiario}
                        </TableCell>
                        <TableCell
                          align="left"
                          className={tableStyles.tableCell}
                          data-testid="table-associated-deductions-cell-business-name"
                        >
                          {deduction.razonSocial}
                        </TableCell>
                        <TableCell
                          align="left"
                          className={tableStyles.tableCell}
                          data-testid="table-associated-deductions-cell-actions"
                        >
                          <MenuActions>
                            <MenuItem>
                              <ButtonAction
                                roles={accesRoles.adminUser}
                                disabled={false}
                                action={() =>
                                  handleRemoveDeduction(deduction.id)
                                }
                                dataTestid="action-remove-retention"
                              >
                                <span>Retirar retención</span>
                              </ButtonAction>
                            </MenuItem>
                          </MenuActions>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
